import { loginFlow, logoutFlow, watchLoginSagas } from "../login/loginSaga";
import { fork, takeEvery, all } from "redux-saga/effects";
import { History } from "history";
import * as LoginStore from '../login/loginStore'
import * as TruckStore from '../trucks/store/truckStore'
import * as TruckSagas from '../trucks/store/sagas'
import * as UnitSagas from "../units/store/sagas";
import * as LoginSagas from "../login/loginSaga";
import * as FeedbackSagas from '../admin/store/feedbackSagas';
import * as StatisticSagas from '../statistics/store/sagas';
import * as RegisterUserSagas from '../register/user/registerUserSagas';
import * as RegisterCompanySagas from '../register/company/registerCompanySagas';
import * as CompanySagas from '../admin/store/companiesSagas';
import * as SettingsSagas from '../account/store/sagas';
import * as GiveFeedbackSagas from '../feedback/store/sagas'
import * as VisibleCompanies from '../companies/store/sagas';
import * as NotificationSagas from '../notifications/store/sagas';
import * as FilterSettingsSagas from '../account/store/FilterSettingsSagas';

export default function* rootSaga(history: History) {

  yield fork(loginFlow, history);
  yield fork(logoutFlow);
  yield fork(LoginSagas.watchLoginSagas);
  yield fork(UnitSagas.watchUnitSagas);
  yield fork(TruckSagas.watchTruckSagas);
  yield fork(FeedbackSagas.watchFeedbackSagas);
  yield fork(RegisterUserSagas.watchRegisterUserSagas);
  yield fork(RegisterCompanySagas.watchRegisterCompanySagas);
  yield fork(StatisticSagas.watchStatisticSagas);
  yield fork(CompanySagas.watchCompaniesSagas);
  yield fork(SettingsSagas.watchSettingsSagas);
  yield fork(GiveFeedbackSagas.watchGiveFeedbackSagas);
  yield fork(VisibleCompanies.watchCompaniesSagas);
  yield fork(NotificationSagas.watchNotificationsSagas);
  yield fork(FilterSettingsSagas.watchSettingsSagas);

  yield all([
    takeEvery("COMMON/REQUEST_ERROR", requestError),
  ])
}

function requestError(error: any) {
  console.log("error happened", error);
}



// WEBPACK FOOTER //
// ./src/store/sagas.ts